<template>
  <div>
    <v-contextmenu ref="contextmenu" :theme="theme">
      <v-contextmenu-item divider></v-contextmenu-item>

      <v-contextmenu-submenu
        @submenu-show="handleSubmenuShow"
        title="대의 파악"
      >
        <v-contextmenu-item @click="handleClick('글의 목적', 1)"
          >글의 목적</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('필자 주장', 2)"
          >필자 주장</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('글의 요지', 3)"
          >글의 요지</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('글의 제목', 4)"
          >글의 제목</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('심경 파악', 5)"
          >심경 파악</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('심경 변화', 6)"
          >심경 변화</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('글의 분위기', 7)"
          >글의 분위기</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('글의 주제', 8)"
          >글의 주제</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('밑줄 의미(함의추론)', 9)"
          >밑줄 의미(함의추론)</v-contextmenu-item
        >
      </v-contextmenu-submenu>

      <v-contextmenu-submenu
        @submenu-show="handleSubmenuShow"
        title="세부 내용 파악"
      >
        <v-contextmenu-item @click="handleClick('내용 일치', 10)"
          >내용 일치</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('내용 불일치', 11)"
          >내용 불일치</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('안내문 일치', 12)"
          >안내문 일치</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('안내문 불일치', 13)"
          >안내문 불일치</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('도표 이해', 14)"
          >도표 이해</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('지칭 추론', 15)"
          >지칭 추론</v-contextmenu-item
        >
      </v-contextmenu-submenu>

      <v-contextmenu-submenu
        @submenu-show="handleSubmenuShow"
        title="어법.문법"
      >
        <v-contextmenu-submenu title="밑줄어법">
          <v-contextmenu-item @click="handleClick('가정법', 201)"
            >가정법</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('관계사', 202)"
            >관계사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('명사/대명사/관사', 203)"
            >명사/대명사/관사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('문형', 204)"
            >문형</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('병렬', 205)"
            >병렬</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('분사', 206)"
            >분사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('비교', 207)"
            >비교</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수동태', 208)"
            >수동태</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수일치', 209)"
            >수일치</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('시제', 210)"
            >시제</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('전치사', 211)"
            >전치사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('접속사', 212)"
            >접속사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('조동사', 213)"
            >조동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('준동사', 214)"
            >준동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('특수구문', 215)"
            >특수구문</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('형용사/부사', 216)"
            >형용사/부사</v-contextmenu-item
          >
        </v-contextmenu-submenu>

        <v-contextmenu-submenu title="네모 어법">
          <v-contextmenu-item @click="handleClick('가정법', 301)"
            >가정법</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('관계사', 302)"
            >관계사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('명사/대명사/관사', 303)"
            >명사/대명사/관사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('문형', 304)"
            >문형</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('병렬', 305)"
            >병렬</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('분사', 306)"
            >분사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('비교', 307)"
            >비교</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수동태', 308)"
            >수동태</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수일치', 309)"
            >수일치</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('시제', 310)"
            >시제</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('전치사', 311)"
            >전치사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('접속사', 312)"
            >접속사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('조동사', 313)"
            >조동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('준동사', 314)"
            >준동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('특수구문', 315)"
            >특수구문</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('형용사/부사', 316)"
            >형용사/부사</v-contextmenu-item
          >
        </v-contextmenu-submenu>

        <v-contextmenu-submenu title="어법성 판단">
          <v-contextmenu-item @click="handleClick('가정법', 401)"
            >가정법</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('관계사', 402)"
            >관계사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('명사/대명사/관사', 403)"
            >명사/대명사/관사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('문형', 404)"
            >문형</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('병렬', 405)"
            >병렬</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('분사', 406)"
            >분사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('비교', 407)"
            >비교</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수동태', 408)"
            >수동태</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수일치', 409)"
            >수일치</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('시제', 410)"
            >시제</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('전치사', 411)"
            >전치사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('접속사', 412)"
            >접속사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('조동사', 413)"
            >조동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('준동사', 414)"
            >준동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('특수구문', 415)"
            >특수구문</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('형용사/부사', 416)"
            >형용사/부사</v-contextmenu-item
          >
        </v-contextmenu-submenu>

        <v-contextmenu-submenu title="영작">
          <v-contextmenu-item @click="handleClick('가정법', 501)"
            >가정법</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('관계사', 502)"
            >관계사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('명사/대명사/관사', 503)"
            >명사/대명사/관사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('문형', 504)"
            >문형</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('병렬', 505)"
            >병렬</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('분사', 506)"
            >분사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('비교', 507)"
            >비교</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수동태', 508)"
            >수동태</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('수일치', 509)"
            >수일치</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('시제', 510)"
            >시제</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('전치사', 511)"
            >전치사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('접속사', 512)"
            >접속사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('조동사', 513)"
            >조동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('준동사', 514)"
            >준동사</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('특수구문', 515)"
            >특수구문</v-contextmenu-item
          >
          <v-contextmenu-item @click="handleClick('형용사/부사', 516)"
            >형용사/부사</v-contextmenu-item
          >
        </v-contextmenu-submenu>
      </v-contextmenu-submenu>
      <v-contextmenu-submenu @submenu-show="handleSubmenuShow" title="어휘">
        <v-contextmenu-item @click="handleClick('밑줄 어휘', 18)"
          >밑줄 어휘</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('네모 어휘', 19)"
          >네모 어휘</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('빈칸에 들어갈 말', 103)"
          >빈칸에 들어갈 말</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('동의어 찾기', 104)"
          >동의어 찾기</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('어색한 어휘 찾기', 105)"
          >어색한 어휘 찾기</v-contextmenu-item
        >
      </v-contextmenu-submenu>
      <v-contextmenu-submenu
        @submenu-show="handleSubmenuShow"
        title="빈칸 추론"
      >
        <v-contextmenu-item @click="handleClick('빈칸 추론', 20)"
          >빈칸 추론</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('연결사', 21)"
          >연결사</v-contextmenu-item
        >
      </v-contextmenu-submenu>
      <v-contextmenu-submenu
        @submenu-show="handleSubmenuShow"
        title="간접 쓰기/흐름파악"
      >
        <v-contextmenu-item @click="handleClick('글의 순서', 22)"
          >글의 순서</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('무관한 문장', 23)"
          >무관한 문장</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('문장 삽입', 24)"
          >문장 삽입</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('요약문 완성', 25)"
          >요약문 완성</v-contextmenu-item
        >
      </v-contextmenu-submenu>
      <v-contextmenu-submenu @submenu-show="handleSubmenuShow" title="장문">
        <v-contextmenu-item @click="handleClick('2문항 장문_주제', 27)"
          >2문항 장문_주제</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('2문항 장문_제목', 106)"
          >2문항 장문_제목</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('2문항 장문_빈칸', 28)"
          >2문항 장문_빈칸</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('2문항 장문_두 개 빈칸', 29)"
          >2문항 장문_두 개 빈칸</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('2문항 장문_내용 불일치', 107)"
          >2문항 장문_내용 불일치</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('2문항 장문_밑줄 어휘', 30)"
          >2문항 장문_밑줄 어휘</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('2문항 장문_요지', 601)"
          >2문항 장문_요지</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('2문항 장문_밑줄 의미', 602)"
          >2문항 장문_밑줄 의미</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('2문항 장문_지칭 추론', 603)"
          >2문항 장문_지칭 추론</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('2문항 장문_시사점', 604)"
          >2문항 장문_시사점</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('3문항 장문_순서', 31)"
          >3문항 장문_순서</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('3문항 장문_내용일치', 108)"
          >3문항 장문_내용일치</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('3문항 장문_지칭추론', 32)"
          >3문항 장문_지칭추론</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('3문항 장문_내용 불일치', 33)"
          >3문항 장문_내용 불일치</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('3문항 장문_밑줄 의미', 710)"
          >3문항 장문_밑줄 의미</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('3문항 장문_빈칸', 702)"
          >3문항 장문_빈칸</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('3문항 장문_시사점', 703)"
          >3문항 장문_시사점</v-contextmenu-item
        >

        <v-contextmenu-item @click="handleClick('3문항 장문_제목', 704)"
          >3문항 장문_제목</v-contextmenu-item
        >


      </v-contextmenu-submenu>
      <v-contextmenu-submenu @submenu-show="handleSubmenuShow" title="생활영어">
        <v-contextmenu-item @click="handleClick('빈칸에 들어갈 말', 37)"
          >빈칸에 들어갈 말</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('자연스러운 대화 찾기', 38)"
          >자연스러운 대화 찾기</v-contextmenu-item
        >
        <v-contextmenu-item @click="handleClick('어색한 대화 찾기', 39)"
          >어색한 대화 찾기</v-contextmenu-item
        >
      </v-contextmenu-submenu>
    </v-contextmenu>

    <b-container>
      <b-row>
        <b-col
          ><div :class="['box', theme]" v-contextmenu:contextmenu>
            출제포인트 선택
          </div></b-col
        >
        <b-col>{{ intent1 }}</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["intentName", "updatenm"],
  data() {
    return {
      intent: "출제포인트 선택",
    };
  },
  computed: {
    intent1() {
      try {
        // let k = this.$store.state.questionform.intent1.text;
        let k = this.$store.state.questionform[this.intentName].text;
        return k;
      } catch (e) {
        return "-";
      }
    },
  },
  methods: {
    handleClick(t1, t2) {
      // alert(t2);
      let val = {
        code: t2,
        text: t1,
      };
      this.intent = t1;
      // let updatenm = "update" + this.intentName;
      // alert(this.updatenm);
      this.$store.commit(this.updatenm, val);
    },
  },
};
</script>


<style lang="scss" scoped>
.box {
  border: 1px solid gray;
  padding: 2px;
  text-align: center;
  background: lightgray;
}
</style>